module.exports = __webpack_public_path__ + "img/participants.eab022dd.png";